import { FiltersObjType } from './jsonConfigs/types'

export function getFiltersArrStr(filtersArr: FiltersObjType[]) {
  return filtersArr.map((e) => `${e.key}, ${e.value.join(', ')}`).join(', ')
}
